import React from "react";
import { Phone, CalendarHeart, MessageCircle, Facebook, LogIn } from "lucide-react";

const Item = ({ as = "a", href, onClick, icon: Icon, label, testid, highlight }) => {
  const inner = (
    <>
      <Icon size={20} className="shrink-0" />
      <span className="text-[11px] font-semibold leading-tight">{label}</span>
    </>
  );
  const cls = `mmm-tap flex flex-col items-center justify-center gap-1 py-2 min-h-[60px] text-white transition-colors ${
    highlight ? "bg-[color:var(--mmm-red)] hover:bg-[#861A1D]" : "hover:bg-white/10"
  }`;
  if (as === "button") {
    return (
      <button type="button" onClick={onClick} data-testid={testid} aria-label={label} className={cls}>
        {inner}
      </button>
    );
  }
  return (
    <a href={href} data-testid={testid} aria-label={label} className={cls}>
      {inner}
    </a>
  );
};

export const StickyMobileFooter = ({
  variant = "fixed",
  phone = "tel:+18165550100",
  consultationHref = "/#consultation",
  onChat,
  facebookHref,
  loginHref = "/login",
  showLogin = true,
  className = "",
}) => {
  const positioning =
    variant === "fixed" ? "fixed inset-x-0 bottom-0 z-40 lg:hidden" : "absolute inset-x-0 bottom-0";
  return (
    <nav
      data-testid="sticky-mobile-footer"
      aria-label="Quick actions"
      className={`${positioning} border-t border-white/10 ${className}`}
      style={{ backgroundColor: "var(--mmm-navy)" }}
    >
      <div className="grid grid-cols-4">
        <Item href={phone} icon={Phone} label="Call" testid="sticky-footer-call" />
        <Item href={consultationHref} icon={CalendarHeart} label="Free Consult" testid="sticky-footer-consultation" highlight />
        <Item as="button" onClick={onChat} icon={MessageCircle} label="Chat" testid="sticky-footer-chat" />
        {facebookHref ? (
          <Item href={facebookHref} icon={Facebook} label="Facebook" testid="sticky-footer-facebook" />
        ) : showLogin ? (
          <Item href={loginHref} icon={LogIn} label="Login" testid="sticky-footer-login" />
        ) : (
          <Item href={facebookHref || "#"} icon={Facebook} label="Facebook" testid="sticky-footer-facebook" />
        )}
      </div>
    </nav>
  );
};
